export enum DermaAppHeader {
    apparaatId = 'x-ksyos-apparaatid',
    inlogToken = 'x-ksyos-inlogtoken',
}
